<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="400" >
        <v-card class="mt-3 pa-1">
            <Title title="調査日誌">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <DatePicker 
                                label="観察日"
                                dense
                                v-model="editItems.date"
                                :clearable="false"
                                :max="maxDate" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field 
                                v-model="editItems.name" 
                                clearable
                                prepend-icon="mdi-emoticon-outline"
                                label="調査者のお名前" 
                                outlined
                                hide-details 
                                type="text" 
                                dense />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="onClickCreateReport"><v-icon>mdi-file-document-outline</v-icon>レポートの作成</v-btn>
            </v-card-actions>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import DatePicker from '@/components/tools/DatePicker';
    import Confirm from '@/components/tools/ConfirmDialog';

    export default {
        components: {
            Title,
            TitleButton,
            DatePicker,
            Confirm
        },
        props: {
            seedlings: null
        },
        data: function () {
            return {
                isView: false,
                /** 編集項目 */
                editItems: {
                    date: null,
                    name: null
                },
                /** 指定可能な最大の作業日 */
                maxDate: (new Date()).toFormatString("yyyy-MM-dd"),
                /** レポートデータ */
                reportData: null,
                /** SeedlingManagerへのコールバック(データ取得等で使用) */
                callbacks: null,
                /** 印刷状態 */
                printState: {
                    currentPage: 1,
                    maxPage: 1
                }
            }
        },
        methods: {
            /**
             * レポートの作成ボタン押下時
             */
            onClickCreateReport: function () {
                const self = this
                this.createReportData(
                    function () {
                        if (self.reportData == null || self.reportData.varieties.length == 0) {
                            self.$refs.confirm.show({
                                title: "観察データ無し",
                                message: "選択された日の観察データがありません。",
                                buttonYes: "戻る",
                                buttonNo: "",
                            })
                            return
                        }
                        self.printState.currentPage = 1
                        self.printState.maxPage = self.reportData.varieties.length
                        self.createReport()
                    }
                )
            },
            /**
             * この画面を表示する。
             */
            show: function (callbackSetObservateListTo, callbackGetPlace, callbackGetCrop, callbackGetVariety) {

                this.callbacks = {
                    setObservateListTo: callbackSetObservateListTo,
                    getPlace: callbackGetPlace,
                    getCrop: callbackGetCrop,
                    getVariety: callbackGetVariety
                }
                
                this.isView = true
            },
            /**
             * サーバーにレポート作成要求を行い、サーバーが作成したレポート(PDF)をダウンロードする
             */
            createReport: function () {
                
                const self = this
                
                this.$store.commit("processing", {start:true, message: "品種:"+this.reportData.varieties[self.printState.currentPage - 1].varietyName+"のレポートを作成しています…。"})
                
                try {
                    const creator = new WebSocket("wss://service.tomson.xyz/myfield_report_creator")
                    const request = {
                        userUID: this.$store.getters["userUID"],
                        reportID: "1000-001",
                        data: {
                            date: this.reportData.date,
                            name: this.reportData.name,
                            variety: this.reportData.varieties[self.printState.currentPage - 1]
                        }
                    }

                    creator.onopen = function (e) {
                        console.log("onopen", e)
                        creator.send(JSON.stringify(request))
                    }
                    creator.onmessage = function (e) {
                        self.$store.commit("processing")
                        creator.close()

                        const link = document.createElement("a")
                        link.href = e.data
                        link.download = "調査日誌_"+self.reportData.date+"_"+self.reportData.varieties[self.printState.currentPage - 1].varietyName
                        link.click()

                        if (self.printState.currentPage < self.printState.maxPage) {
                            self.printState.currentPage++
                            self.createReport()
                        } else {
                            self.isView = false
                        }
                    }
                    creator.onclose = function (e) {
                        self.$store.commit("processing")
                        console.log("onclose", e)
                    }
                    creator.onerror = function (e) {
                        console.log("onerror", e)
                        creator.close()
                        self.$store.commit("processing")
                        self.$store.commit("notification", {message:"レポート作成に失敗しました。", isError: true})
                        self.mi_writeLog("KamotoReport_001/createReport", "レポート作成に失敗しました。("+e+")")
                        return
                    }
                } catch (error) {
                    this.$store.commit("processing")
                    this.$store.commit("notification", {message:"レポート作成に失敗しました。", isError: true})
                    this.mi_writeLog("KamotoReport_001/createReport", "レポート作成に失敗しました。("+error+")")
                }
            },
            /**
             * レポートデータを作成
             */
            createReportData: function (completed) {

                const self = this

                this.$store.commit("processing", {start:true, message:"データを収集中です…。"})

                try {
                    const targetDate = this.editItems.date
                    const targetValueID = 50
                    const observates = []

                    // 収集した観察データから葉数の観察データのみを取得し
                    // 場所毎に集計する
                    const createReportData = function () {
                        self.reportData = {
                            name: self.editItems.name,
                            date: targetDate,
                            varieties: []
                        }

                        var currentVariety = null
                        var currentPlace = null

                        for (var observate of observates) {
                            const leafNumValue = observate.body.values.find((v)=>v.id == targetValueID)
                            if (leafNumValue != null) {
                                if (currentVariety == null || currentVariety.cropID != observate.seedling.variety.cropID || currentVariety.varietyID != observate.seedling.variety.varietyID) {
                                    currentVariety = {
                                        cropName: self.callbacks.getCrop(observate.seedling.variety.cropID).name,
                                        cropID: observate.seedling.variety.cropID,
                                        varietyName: self.callbacks.getVariety(observate.seedling.variety.cropID, observate.seedling.variety.varietyID).name,
                                        varietyID: observate.seedling.variety.varietyID,
                                        places: []
                                    }
                                    currentPlace = null
                                    self.reportData.varieties.push(currentVariety)
                                }

                                if (currentPlace == null || currentPlace.place != observate.body.seedlingPlace.place) {
                                    currentPlace = {
                                        place: observate.body.seedlingPlace.place,
                                        placeName: self.callbacks.getPlace(observate.body.seedlingPlace.place).name,
                                        leafNumTotal: 0,
                                        leafNumAve: 0,
                                        seedlings: []
                                    }
                                    currentVariety.places.push(currentPlace)
                                }

                                currentPlace.seedlings.push(
                                    {
                                        seedlingID: observate.seedling.seedlingID,
                                        seedlingName: observate.seedling.name,
                                        leafNum: leafNumValue.value * 1
                                    }
                                )
                                currentPlace.leafNumTotal += (leafNumValue.value * 1)
                                currentPlace.leafNumAve = currentPlace.leafNumTotal / currentPlace.seedlings.length
                            }
                        }

                        self.$store.commit("processing")

                        console.log("report data created!!", self.reportData)
                        
                        completed()
                    }

                    // 指定された苗が持つ観察データから対象日の観察データのみを収集する
                    // 全ての苗の観察データを収集した後は、場所+苗IDで並び替えを行い
                    // その後に、レポート用のJSONデータを作成する
                    const getTargetObservateData = function (seedling, isLast) {
                        for (var observate of seedling.observates) {
                            if (observate.date == targetDate) {
                                observates.push(
                                    {
                                        seedling: seedling.body,
                                        body: observate
                                    }                                    
                                )
                                console.log(observate.seedlingPlace.place, observate.seedlingID)
                            }
                        }
                        if (isLast) {
                            console.log("最終の苗", observates)
                            observates.sort(function(x, y) {
                                if (x.seedling.variety.cropID > y.seedling.variety.cropID) return 1
                                if (x.seedling.variety.cropID < y.seedling.variety.cropID) return -1
                                if (x.seedling.variety.varietyID > y.seedling.variety.varietyID) return 1
                                if (x.seedling.variety.varietyID < y.seedling.variety.varietyID) return -1
                                if (x.body.seedlingPlace.place > y.body.seedlingPlace.place) return 1
                                if (x.body.seedlingPlace.place < y.body.seedlingPlace.place) return -1
                                if (x.seedling.seedlingID > y.seedling.seedlingID) return 1
                                if (x.seedling.seedlingID < y.seedling.seedlingID) return -1
                                return 0
                            })
                            createReportData()
                        }
                    }

                    // 取得している苗毎に、観察データから対象日の観察データを取得して収集する
                    // 観察データを取得していない苗は観察データを取得してから処理する
                    this.seedlings.forEach(function (seedling, index, array) {
                        if (seedling.observates == null) {
                            self.callbacks.setObservateListTo(
                                seedling, 
                                function() {
                                    console.log("setObservateListTo callback", index, self.seedlings.length - 1)
                                    getTargetObservateData(seedling, index == self.seedlings.length - 1 ? true : false)
                                }
                            )
                        } else {
                            console.log("seedling observate cached", index, self.seedlings.length - 1)
                            getTargetObservateData(seedling, index == self.seedlings.length - 1 ? true : false)
                        }
                    })

                } catch (error) {
                    self.$store.commit("processing")
                    self.$store.commit("notification", {message:"レポートデータの収集に失敗しました。", isError:true})
                    self.mi_writeLog("SeedlingManager/onSelectedKamotoReport_001", "レポートデータの収集に失敗しました。("+error+")")
                }
            },
        }
    }
</script>
